import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import buildPlotData from '../data'; // Importing as default export
import getTemperatureUnit from '../common/tempHtmlCode.js';
import Logo from './Logo.js';
import './results.css';

function Results({ plotData, stateData, advancedUser }) {
  const [finalPlotData, setFinalPlotData] = useState({});
  const [showLogo, setShowLogo] = useState(false);
  const [hasReceivedData, setHasReceivedData] = useState(false);
  const [isFirstApiCall, setIsFirstApiCall] = useState(true);



  const handleLogoDoubleClick = () => {
    localStorage.removeItem('zuta');
    localStorage.removeItem('uname');

  };


  useEffect(() => {
    if (plotData) {
      // Get the layout data from data.js based on the plotData
      console.log("plotData", plotData);
      console.log("isFirstApiCall", isFirstApiCall);

      if (isFirstApiCall) {
        // First API call - show logo only, no chart
        setShowLogo(true);
        setIsFirstApiCall(false);
      } else {
        // Subsequent API calls - hide logo and show chart immediately
        const newPlotData = buildPlotData(plotData, advancedUser ? null : stateData.HruType);
        console.log("Setting finalPlotData for subsequent API call:", newPlotData);
        setFinalPlotData(newPlotData);
        setShowLogo(false);
      }
    } else {
      console.log("plotData", plotData);
      setShowLogo(false);
    }
    // eslint-disable-next-line
  }, [plotData, advancedUser]);

  function convertThousandsToKilowatts(number) {

    if (number < 1000) {
      return `${number} W`;
    }

    const kilowatts = number / 1000;
    return `${kilowatts} kW`;
  }

  // Debug logging
  console.log("Render check - plotData:", !!plotData, "isFirstApiCall:", isFirstApiCall, "finalPlotData:", !!finalPlotData, "finalPlotData keys:", finalPlotData ? Object.keys(finalPlotData).length : 0);

  return (
    <div className={`col-lg-${advancedUser ? 12 : 7} col-md-12 col-sm-12"`} style={{ height: `${advancedUser ? '90vh' : 'auto'}` }}>
      <div className='reaultCtrParent'>
        <div className='resultCtr'>
        {plotData && finalPlotData && Object.keys(finalPlotData).length > 0 ? (
          <div className={`chartCtr ${advancedUser ? 'chartCtrAdvanced' : ''}`}>
            <div className='someData'>
              <span>
                <span style={{color:"#fff"}}>Saturation:</span>
                <span style={{color:"#01B4DC", marginLeft: "10px", fontWeight:900, textShadow:"rgba(0, 0, 0, 0.9) 2px 2px 11px"}}>{plotData.saturation}{getTemperatureUnit(plotData.measurementSystem)}</span>
              </span>
              <span>
                <span style={{color:"#fff"}}>Total cooling/Compute power:</span>
                <span style={{color:"#01B4DC", marginLeft: "10px", fontWeight:900, textShadow:"rgba(0, 0, 0, 0.9) 2px 2px 11px"}}>{convertThousandsToKilowatts(plotData.totalRackPower)}</span>
              </span>
            </div>
            {finalPlotData && <Plot
              data={finalPlotData.plotData}
              layout={finalPlotData.layout}
              config={finalPlotData.config}
              useResizeHandler={true}
              style={{width: "100%", height: "100%"}}
            />
            }
            <div className='comments' style={{color: '#fff', marginTop: '10px', fontWeight: 500}}>
              {plotData.comment && (
                <>
                  Notice: {typeof plotData.comment === 'string' ? plotData.comment : JSON.stringify(plotData.comment)}
                </>
              )}
            </div>
          </div>

        ) : (
          <Logo key="logo1" />
        )}
        {showLogo && (
          <div className='logoBottom'>
            <img
              src='./build/pics/logo.svg'
              alt='Logo'
              onDoubleClick={handleLogoDoubleClick}
              style={{ opacity: showLogo ? 0.9 : 0, transform: showLogo ? 'scale(1.1)' : 'scale(0)' }}
            />
          </div>
        )}
        </div>
      </div>
    </div>
  );
}

export default Results;
